import React from 'react'
import { compose, Query } from 'react-apollo'
import { Form, Modal, Button, Spin } from 'antd'
// import _get from 'lodash/get'
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl'
// import Script from 'react-load-script'
// import _get from 'lodash/get'
// import CardReactFormContainer from 'card-react'
import creditcardBrands from '~/assets/creditcard_brands.png'
import userCardsQuery from '~/App/graphql/queries/userCards.gql'
import CardInput from './CardInput'

const CardModal = compose(
  injectIntl,
  Form.create()
)(({
  amount,
  visible,
  loading: paymentLoading,
  onClose,
  onSubmit,
  form: { getFieldDecorator, getFieldValue, validateFields }
  // publicKey
}) => {
  // const [omiseLoaded, setOmiseLoaded] = useState(false)
  const handleSubmit = e => {
    e.preventDefault()
    validateFields(async (err, data) => {
      if (err) {
        console.error(err)
        return
      }
      const { cardId, newCard, saveCard } = data
      return onSubmit({ cardId, newCard, saveCard })
    })
  }
  // const saveCardDecorator = getFieldDecorator('saveCard', {
  //   valuePropName: 'checked',
  //   initialValue: true,
  // })
  const newCardDecorator = getFieldDecorator('newCard')
  return <Modal visible={visible} footer={null} width={400} onCancel={onClose}>
    <Form onSubmit={handleSubmit} layout="vertical">
      <Query query={userCardsQuery} fetchPolicy="network-only">
        {({ data, loading }) => {
          if (loading) {
            return <div className="modLoadding">
              <Spin tip="Loading..." size="large" />
            </div>
          }
          if (!data) return <div>Data not found</div>
          // const defaultCardId = _get(data, 'currentUser.customer.default_card_id')
          // const cards = _get(data, 'currentUser.customer.cards.data', [])
          getFieldDecorator('cardId', {
            initialValue: 'new'
          })
          const cardId = getFieldValue('cardId')
          // const cardId = 'new'
          return <React.Fragment>
            {/* {cardIdDecorator(
                    <Radio.Group>
                      {cards.map(card =>
                        <Radio style={radioStyle} key={card.id} value={card.id} ><strong>{card.brand}  ****{card.last_digits}</strong> {card.name}</Radio>
                      )}
                      <Radio style={radioStyle} key="new" value="new"><FormattedMessage id="app.newCard" defaultMessage="New credit/debit card" /></Radio>
                    </Radio.Group>
                  )} */}
            {cardId === 'new' && newCardDecorator(<CardInput />)}
            {/* {cardId === 'new' && saveCardDecorator(<Checkbox><FormattedMessage id="app.saveCard" defaultMessage="Remember this card" /></Checkbox>)} */}
            <div className="submitBlock">
              <Button htmlType="submit" icon="lock" loading={paymentLoading} type="primary">
                <FormattedMessage id="app.payRequest.amount" values={{ amount: <FormattedNumber value={amount} /> }} />
              </Button>
            </div>
            <div className="creditcardBrands">
              <img src={creditcardBrands} alt="" />
            </div>
          </React.Fragment>
        }}
      </Query>
    </Form>
  </Modal >
})

export default CardModal



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseCard/CardModal.js